import React from 'react'
import './styles.scss'

import brazilianStates from '../../constants/brazilian-states'
import { useCommonStyles } from 'styles/globalStyles'

interface Props {
  value?: string
  onChange: (value: string) => void | void
  placeholder?: string
  error?: string
}

const LocaleSelect = (props: Props) => {
  const commonClasses = useCommonStyles(props)

  return (
    <div>
      <select
        value={props.value}
        className={commonClasses.inputSelect}
        onChange={(e) => {
          props.onChange(e.target.value)
        }}
      >
        <option disabled value=''>
          {props.placeholder}
        </option>
        {brazilianStates.map((state) => (
          <option key={state.acronym} value={state.acronym}>
            {state.name}
          </option>
        ))}
      </select>
      {!!props.error && <span className={commonClasses.errorInputText}>{props.error}</span>}
    </div>
  )
}

LocaleSelect.defaultProps = {
  placeholder: 'Selecione o seu Estado',
}

export default LocaleSelect
